import { useState } from 'react';
import { Picker } from './ProjectsView';
import './CheckRail.css';

// ============================================================
// CHECK RAIL — the sweep's sender-only attaches (report.check[]): the
// weak routes, one white row each for the operator to eyeball. A live
// sweep result carries the full row { watchId, title, by, proving }; the
// persisted last report carries { watchId, by } only, so on a page load
// the row is the reduced "#N · filed by <by>" and still moves.
//
//   ✓     dismiss the row — display only, nothing written
//   MOVE  the Projects view's Picker over the open cards; a pick hands
//         (row, targetWatchId) up — the parent PATCHes the source row(s)
//         (WatchId + RoutedBy 'attach') and drops the row
//
// Pure presentation: no fetch, no MSAL.
// ============================================================

export const checkKey = (r) => `k:${r.watchId}:${r.proving?.internetMessageId || r.by || ''}`;

export default function CheckRail({ rows = [], reduced = false, byId = new Map(), items = [], onDismiss, onMove, busyKeys = new Set() }) {
  const [moveFor, setMoveFor] = useState(null);
  if (!rows.length) return null;
  const options = items.filter(i => i.status === 'Open').sort((a, b) => b.id - a.id).map(i => ({ id: i.id, label: i.title || `#${i.id}`, hint: `#${i.id}` }));
  return (
    <div className="CheckRail" data-testid="check-rail">
      {rows.map(r => {
        const key = checkKey(r);
        const title = r.title || byId.get(r.watchId)?.title || '';
        const busy = busyKeys.has(key);
        return (
          <div key={key} className={'CheckRail-row' + (busy ? ' CheckRail-row--busy' : '')} data-testid={key} aria-busy={busy || undefined}>
            <span className="CheckRail-id">#{r.watchId}</span>
            {!reduced && title && <span className="CheckRail-title" title={title}>{title}</span>}
            <span className="CheckRail-by">filed by {r.by}</span>
            {!reduced && r.proving?.subject && <span className="CheckRail-subject" title={r.proving.subject}>{r.proving.fromName || r.proving.from}{' · '}{r.proving.subject}</span>}
            <span className="CheckRail-actions">
              <button type="button" className="CheckRail-btn CheckRail-btn--ok" aria-label={`Looks right, #${r.watchId}`} title="Looks right — dismiss" disabled={busy} onClick={() => onDismiss?.(r)}>✓</button>
              <span className="CheckRail-move">
                <button type="button" className="CheckRail-btn CheckRail-btn--move" aria-label={`Move the thread off #${r.watchId}`} aria-expanded={moveFor === key} disabled={busy}
                  onClick={() => setMoveFor(m => (m === key ? null : key))}>MOVE</button>
                {moveFor === key && (
                  <Picker testId={`check-move-${r.watchId}`} placeholder="Move to card…" options={options.filter(o => o.id !== r.watchId)}
                    onCancel={() => setMoveFor(null)} onPick={(id) => { setMoveFor(null); onMove?.(r, id); }} />
                )}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
